export default __webpack_public_path__ + "static/media/bills.ecfd8558.webp";